export default "__VITE_ASSET__5tgu5y0S__"